import React, {useMemo, useRef} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import getCloudinaryVideoUrl from '../../../../cloudinary-media/video'
import breakpoints from '../../../../../theme/foundations/breakpoints'

const Video = ({
    desktopVideo,
    mobileVideo,
    mobileVideoThumbnail,
    videoAlt,
    aspectRatio,
    cloudinaryAspectRatio
}) => {
    const videoRef = useRef(null)
    const videoAspectRatio = cloudinaryAspectRatio || aspectRatio?.replaceAll('/', ':')
    const mobileVideoSrc = useMemo(
        () =>
            mobileVideo?.indexOf('ar_') !== -1
                ? mobileVideo
                : getCloudinaryVideoUrl({
                      src: mobileVideo,
                      aspectRatio: videoAspectRatio
                  }),
        [mobileVideo, videoAspectRatio]
    )
    const desktopVideoSrc = useMemo(
        () =>
            desktopVideo?.indexOf('ar_') !== -1
                ? desktopVideo
                : getCloudinaryVideoUrl({
                      src: desktopVideo,
                      aspectRatio: videoAspectRatio
                  }),
        [desktopVideo, videoAspectRatio]
    )

    return (
        <Box gridArea="1 / 1" width="100%" height="100%">
            <video
                ref={videoRef}
                poster={
                    mobileVideoThumbnail
                        ? mobileVideoThumbnail
                        : `${mobileVideo?.replace('mp4', '')}webp`
                }
                {...{autoPlay: true}}
                muted
                alt={videoAlt}
                loop
                playsInline
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    aspectRatio: aspectRatio || 'unset'
                }}
            >
                <source src={mobileVideoSrc} media={`(max-width: ${breakpoints.md})`} />
                <source src={desktopVideoSrc} />
            </video>
        </Box>
    )
}

Video.propTypes = {
    desktopVideo: PropTypes.string.isRequired,
    mobileVideo: PropTypes.string,
    mobileVideoThumbnail: PropTypes.string,
    videoAlt: PropTypes.string,
    videoEnableSound: PropTypes.bool,
    aspectRatio: PropTypes.string,
    cloudinaryAspectRatio: PropTypes.string,
    videoDisableAutoPlay: PropTypes.bool
}

export default Video
